export default "__VITE_ASSET__BGh_9mJG__"